import React, { useState, useEffect } from "react";
import "../assets/css/SidebarComponents/Flashcard.css";
import { Row } from "reactstrap";
import { flashcardsTranslation, flashcardAnswers } from "views/english";
import { useLanguage } from "context/LanguageProvider";
import { useDarkMode } from "context/DarkModeProvider";



const Flashcard = ({ front, back, flipped, onFlip, onCorrect, onWrong }) => {
  const [isFlipping, setIsFlipping] = useState(false);
  const [answerStatus, setAnswerStatus] = useState("");
  const { darkMode } = useDarkMode();
  const [isExiting, setIsExiting] = useState(false);

  const handleFlip = () => {
    setIsFlipping(true);
    setTimeout(() => setIsFlipping(false), 600);
    onFlip();
  };

  const handleCorrect = () => {
    setAnswerStatus("correct");
    setIsExiting(true);
    setTimeout(() => {
      onCorrect?.();    // το parent αλλάζει κάρτα
    }, 500);
  };

  const handleWrong = () => {
    setAnswerStatus("wrong");
    setIsExiting(true);
    setTimeout(() => {
      onWrong?.();
    }, 500);
  };

  const cardClasses = [
    "flashcard",
    !flipped && "with-shadow",
    isFlipping && "flipping",
    answerStatus === "correct" && "correct-shadow",
    answerStatus === "wrong" && "wrong-shadow",
    isExiting && "slide-out"
  ].filter(Boolean).join(" ");


  const s = localStorage.getItem("structureLocation");

  const colorSchemes = {
    HashTable: { primary: '#10b981', secondary: '#059669', accent: '#d1fae5' },
    Tree: { primary: '#3b82f6', secondary: '#2563eb', accent: '#dbeafe' },
    List: { primary: '#8b5cf6', secondary: '#7c3aed', accent: '#ede9fe' },
    Stack: { primary: '#f59e0b', secondary: '#d97706', accent: '#fef3c7' },
    Queue: { primary: '#ef4444', secondary: '#dc2626', accent: '#fecaca' },
    Graph: { primary: '#06b6d4', secondary: '#0891b2', accent: '#cffafe' },
    Array: { primary: '#ec4899', secondary: '#db2777', accent: '#fce7f3' },
    Set: { primary: '#84cc16', secondary: '#65a30d', accent: '#ecfccb' },
    Python: { primary: '#3776ab', secondary: '#ffd43b' }

  };

  const scheme = colorSchemes[s] || colorSchemes.Graph;

  const { selLanguage, toggleLanguage, isLoading } = useLanguage();

  return (
    <div className={cardClasses} onClick={handleFlip}>
      <div className={`flashcard-inner ${flipped ? "flipped" : ""}`}>

        {/* Front Side */}
        <div
          className="flashcard-front"
          style={{
            background: darkMode
              ? `linear-gradient(135deg, ${scheme.primary}25 0%, ${scheme.secondary}25 100%)`
              : `${scheme.primary}95`, // 33 = ~20% opacity
            backdropFilter: 'blur(10px)',
            border: `1px solid ${scheme.primary}30`,
            // boxShadow: `0 10px 25px -8px ${scheme.primary}20`,
          }}
        >

          <p>
            {isLoading ? "..." : selLanguage ? front : flashcardsTranslation[front] || front}
          </p>


          {!flipped && (
            <div className="click-to-flip">
              <span className="click-to-flip-text" style={{ display: "inline-flex", alignItems: "center", gap: "0.5em" }}>
                {selLanguage ? "Πάτα για να γυρίσει" : "Click to flip"}
              </span>
              <span style={{ marginLeft: "5px", marginTop: "5px" }} className="fa-solid fa-arrow-rotate-right"></span>
            </div>
          )}


        </div>

        {/* Back Side */}
        <div
          className="flashcard-back"
          style={{
            background: darkMode ? `linear-gradient(135deg, ${scheme.primary}25 0%, ${scheme.secondary}25 100%)` : `${scheme.primary}95`,
            backdropFilter: 'blur(10px)',
            border: `1px solid ${scheme.primary}30`,
            // boxShadow: `0 10px 25px -8px ${scheme.primary}20`,
          }}

        >
          <p>{selLanguage ? back : flashcardAnswers[back] || back}</p>

          <div className="answer-buttons">
            <button
              className="answer-button red"
              onClick={(e) => {
                e.stopPropagation();
                handleWrong();
              }}
            >
              <i className="fas fa-xmark" />
            </button>

            <button
              className="answer-button green"
              onClick={(e) => {
                e.stopPropagation();
                handleCorrect();
              }}
            >
              <i className="fas fa-check" />
            </button>
          </div>
        </div>
      </div>
    </div >
  );
};

export default Flashcard;